export const transformVersionRef = (ref: string, id: string) => `${ref.slice(0, 4)}xxx${ref.slice(-5)}:ID_${id}`;

export const transformDate = (date: string, locale: string) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString(locale, {
    hour: "numeric",
    minute: "numeric",
  });
};

export const getCutName = (text: string, max: number) => text.length > max ? `${text.slice(0, max)}...` : text;
